export interface CameraDisplayRecord {
  camera_esn?: string | null;
  camera_esn_display?: string | null;
  entry_camera_esn?: string | null;
  exit_camera_esn?: string | null;
}

export function displayCameraEsn(record: CameraDisplayRecord | null | undefined): string {
  if (!record) {
    return '-';
  }

  if (record.camera_esn_display) {
    return record.camera_esn_display;
  }

  const entryCamera = record.entry_camera_esn || '';
  const exitCamera = record.exit_camera_esn || '';

  if (entryCamera && exitCamera) {
    return entryCamera === exitCamera ? entryCamera : `${entryCamera} & ${exitCamera}`;
  }

  return entryCamera || exitCamera || record.camera_esn || '-';
}
